import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { renderExtraInvoicingRows } from 'redux/modules/invoice/helper';

export class InvoiceDetailsInvoicingColumn extends React.Component {

  static propTypes = {
    showMoreIsVisible: PropTypes.bool,
    invoice: PropTypes.object
  };

  isPreReported (invoice) {
    return invoice.preReport || (invoice.preReportedAt && !!Date.parse(invoice.preReportedAt));
  }

  messageTypeTranslated (messageType) {
    switch (messageType) {
      case 'email':
        return proxyCounterpart('INVOICING_OPTION_EMAIL');
      case 'mail':
        return proxyCounterpart('INVOICING_OPTION_MAIL');
      case 'sms':
        return proxyCounterpart('INVOICING_OPTION_SMS');
      case 'e-invoice':
        return proxyCounterpart('INVOICING_OPTION_EINVOICE');
      default:
        return messageType;
    }
  }

  render () {
    let invoice = this.props.invoice;
    if (invoice) {
      return (<div
        className={'invoice-details-row-column' + (this.props.showMoreIsVisible ? ' padding-no-top' : ' padding')}
      >
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_INVOICING_DETAILS' />
        <div className='invoice-details-row'>
          <b><Translate content='INVOICE_DETAILS_INVOICING_ORDER_NUMBER' />: </b>{invoice.id}
        </div>
        <div className='invoice-details-row'>
          <b><Translate content='INVOICE_DETAILS_INVOICING_ORDER_SENT_AS' />: </b>
          {this.messageTypeTranslated(invoice.messageType)}
        </div>
        {renderExtraInvoicingRows(invoice)}
        <div className='invoice-details-row-divider'></div>
        <div className='invoice-details-row'>
          <b><Translate content='INVOICE_DETAILS_INVOICING_VIEW_HOURS' />: </b>
          {invoice.displayHours ? <Translate content='YES' /> : <Translate content='NO' />}
        </div>
        <div className='invoice-details-row'>
          <b><Translate content='INVOICE_DETAILS_INVOICING_REGISTERED_ASSIGNMENT' />: </b>
          {this.isPreReported(invoice) ? <Translate content='YES' /> : <Translate content='NO' />}
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsInvoicingColumn;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/invoicing-column.js
 **/